import { appListQueries } from 'v5/core/list-query/appListQueries';
import { ZodType } from 'zod';
import {
  createPersistentBrowserHistory,
  PatternConfig,
  PersistentNavigationConfig
} from './createPersistentBrowserHistory';
import { listPersistence } from './listPersistence';

type QueryParams = Record<string, unknown>;

const config: PersistentNavigationConfig<QueryParams> = {
  patterns: Object.values(appListQueries).flatMap(entry =>
    listPersistence({
      listId: entry.listId,
      schema: entry.schema as ZodType<QueryParams>,
      routes: [...entry.routes]
    })
  ) as Array<PatternConfig<QueryParams>>
};

/**
 * Main-app browser history with persistent list query params (from appListQueries).
 */
export const myPersistentBrowserHistory =
  createPersistentBrowserHistory(config);
